// eslint-disable-next-line import/no-mutable-exports
let config;

const DEVELOPMENT = {
  BASE_URL: 'http://10.5.4.148:8085/acionamento-prestador/api/v1',
  BASEWS_URL: 'ws://10.5.4.148:8085/acionamento-prestador/api/v1/ws/clinica/assistservico',
};

const QA = {
  BASE_URL: 'https://gw.dev.tempoassist.cloud/atendimento/acionamento-prestador/api/v1',
  BASEWS_URL:
    'wss://gw.dev.tempoassist.cloud/atendimento/acionamento-prestador/api/v1/ws/clinica/assistservico',
};

const HML = {
  BASE_URL: 'https://gw.hml.tempoassist.cloud/atendimento/acionamento-prestador/api/v1',
  BASEWS_URL:
    'wss://gw.hml.tempoassist.cloud/atendimento/acionamento-prestador/api/v1/ws/clinica/assistservico',
};

const PRODUCTION = {
  BASE_URL: 'https://gw.prd.tempoassist.cloud/atendimento/acionamento-prestador/api/v1',
  BASEWS_URL:
    'wss://gw.prd.tempoassist.cloud/atendimento/acionamento-prestador/api/v1/ws/clinica/assistservico',
};

if (process.env.REACT_APP_ENV === 'prd') {
  config = PRODUCTION;
} else if (process.env.REACT_APP_ENV === 'hml') {
  config = HML;
} else if (process.env.REACT_APP_ENV === 'qa') {
  config = QA;
} else {
  config = DEVELOPMENT;
}

export { config };
